import React from 'react'
import { useTranslation } from 'react-i18next'
import { DayButtonProps } from '../types'

export const DayButton = (props: DayButtonProps) => {
  const { day, modifiers, getPrice, isShowIcon = true, ...buttonProps } = props
  const { t } = useTranslation()
  const price = getPrice(day.date)
  const isWeekday = day.date.getDay() >= 1 && day.date.getDay() <= 5

  return (
    <button
      {...buttonProps}
      className={`
        flex flex-col h-16 items-center mt-1
        ${isShowIcon ? 'justify-center' : 'justify-center'}
        ${modifiers.listed ? 'border border-gray-300' : ''}
        ${modifiers.available ? 'border-green' : ''}
        ${modifiers.startRange || modifiers.endRange ? 'bg-green' : ''}
        ${modifiers.startRange ? 'rounded-l' : modifiers.endRange ? 'rounded-r' : modifiers.inRange ? '' : 'rounded'}
        ${modifiers.inRange && isWeekday ? 'bg-green-100 w-full' : 'w-12'}
      `}
      disabled={!modifiers.available}
    >
      <div
        className={`relative
          ${modifiers.available && !modifiers.inRange ? 'underline font-bold' : ''}
          ${modifiers.startRange || modifiers.endRange ? 'text-white' : modifiers.available ? 'text-primary' : 'text-gray-200'}
        `}
      >
        {day.date.getDate()}
        {modifiers.holiday && (
          <span className="absolute text-red-500 font-size-12 font-normal" style={{ marginTop: '-4px' }}>
            *
          </span>
        )}
      </div>
      {isShowIcon && (
        <>
          {modifiers.listed && modifiers.available && (
            <div
              className={`
                w-3 h-3 rounded-full border-2 border-solid
                ${modifiers.startRange || modifiers.endRange ? 'border-white' : 'border-green'}
              `}
            />
          )}
          {modifiers.listed && !modifiers.available && <span className="text-gray-400 font-size-12">満枠</span>}
        </>
      )}

      {modifiers.listed && (
        <div
          className={`
            font-size-12
            ${modifiers.startRange || modifiers.endRange ? 'text-white' : modifiers.available ? 'text-green' : 'text-gray-200'}
          `}
        >
          {price}
          {price ? t('reservation_confirm.modal_booking.currency_man') : ''}
        </div>
      )}
    </button>
  )
}
